import { render, staticRenderFns } from "./yearDangerWasterData.vue?vue&type=template&id=574c40be&scoped=true&"
import script from "./yearDangerWasterData.vue?vue&type=script&lang=js&"
export * from "./yearDangerWasterData.vue?vue&type=script&lang=js&"
import style0 from "./yearDangerWasterData.vue?vue&type=style&index=0&id=574c40be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574c40be",
  null
  
)

export default component.exports